<div class="header">
    <div class="box-6 logo">
        <ul>
            <li>
                <a [routerLink]="getRoute('providers')" title="home"> <img src="assets/images/logo.png" /></a>
            </li>
            <li>
                <a [routerLink]="getRoute('providers')" title="home"><span class="online-payment-header">Online payment</span> </a>
            </li>
        </ul>
    </div>
    <div class="box-6 nav-right">
        <ul>
            <li>
                <a href="tel:+37410605555" title="+374 10 605555" class="tel">+374 10 605555</a>
            </li>
            <li>
                <div class="dropdown">
                    <span>
                      <img src="assets/images/language.png" title="language" alt="language">
                    </span>
                    <div class="dropdown-content">
                        <ul>
                            <li *ngFor="let lang of Languages" (click)="changeLanuage(lang.code)" class="change-language"> {{lang.display}} </li>
                        </ul>
                    </div>
                </div>
            </li>
            <li>
                <a [routerLink]="getRoute('paymenthistory')" title="History" class="history">{{ 'Title.TitleHistory' | translate }}</a>
            </li>
        </ul>
    </div>
</div>
<div class="m-header">
    <div class="flex-box">
        <div class="box-6">
            <a [routerLink]="getRoute('providers')" title="home"> <img src="assets/images/logo_m.png" title="logo_m" alt="logo_m"></a>

        </div>
        <div class="box-6">
            <ul>
                <li>
                    <a href="tel:+37410605555" title="+374 10 605555"><img src="assets/images/phone_m.png" title="language" alt="language"></a>
                </li>
                <li>
                    <div class="dropdown">
                        <span>
                          <img src="assets/images/language.png" title="language" alt="language">
                        </span>
                        <div class="dropdown-content">
                            <ul>
                                <li *ngFor="let lang of Languages" (click)="changeLanuage(lang.code)" class="change-language"> {{ lang.display }} </li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="flex-box">
        <div class="box-12">
            <a [routerLink]="getRoute('paymenthistory')" title="History" class="history"> {{ 'Title.TitleHistory' | translate }}</a>
        </div>
    </div>
</div>
